var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.InfoCard,
    { attrs: { title: _setup.t("Редакция СМИ", _setup.options) } },
    [
      _c(
        "ul",
        {
          staticClass: "document-list text-body-2 ma-0 pa-0",
          attrs: { "data-qa": "document_media_list" },
        },
        [
          _c(
            "li",
            {
              staticClass: "document-list__item mb-3",
              attrs: { "data-qa": "document_media_item" },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_setup.t("Сайт", _setup.options)) +
                  "\n      "
              ),
              _c(
                "a",
                {
                  staticClass: "link-decoration-underline primary--text",
                  attrs: {
                    href: "/",
                    "data-qa": "document_media_site_link",
                    target: "_blank",
                    rel: "noopener noreferrer",
                  },
                },
                [_vm._v("\n        " + _vm._s(_vm.siteDomain) + "\n      ")]
              ),
              _vm._v(
                "\n      " +
                  _vm._s(
                    _setup.t(
                      "зарегистрирован Федеральной службой по надзору в сфере связи,",
                      _setup.options
                    )
                  ) +
                  "\n      " +
                  _vm._s(
                    _setup.t(
                      "информационных технологий и массовых коммуникаций (Роскомнадзор).",
                      _setup.options
                    )
                  ) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass: "document-list__item mb-3",
              attrs: { "data-qa": "document_media_item" },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_setup.t("Свидетельство", _setup.options)) +
                  "\n      "
              ),
              _c(
                _setup.CorePRG,
                {
                  attrs: {
                    url: "https://rkn.gov.ru/activity/mass-media/for-founders/media/?id=446956",
                    "button-attrs": {
                      class: "link-decoration-underline primary--text pa-0",
                      "data-qa": "document_media_certificate_link",
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _setup.t(
                          "ЭЛ № ФС 77 - 89293 от 01.04.2025 г.",
                          _setup.options
                        )
                      ) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass: "document-list__item mb-3",
              attrs: { "data-qa": "document_media_item" },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _setup.t(
                      "Учредитель СМИ (издатель) ООО «МЕДРОКЕТ»",
                      _setup.options
                    )
                  ) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass: "document-list__item mb-3",
              attrs: { "data-qa": "document_media_item" },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _setup.t(
                      "Главный редактор - Федосов Сергей Ростиславович",
                      _setup.options
                    )
                  ) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass: "document-list__item mb-3",
              attrs: { "data-qa": "document_media_item" },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _setup.t("Адрес редакции (издателя):", _setup.options)
                  ) +
                  "\n      " +
                  _vm._s(_setup.editorialAddress) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass: "document-list__item mb-3",
              attrs: { "data-qa": "document_media_item" },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_setup.t("Телефон:", _setup.options)) +
                  "\n      "
              ),
              _c(
                "a",
                {
                  staticClass: "link-decoration-underline primary--text",
                  attrs: {
                    href: "tel:+74953749356",
                    "data-qa": "document_media_phone_link",
                  },
                },
                [_vm._v("\n        8 (495) 374-93-56\n      ")]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass: "document-list__item mb-3",
              attrs: { "data-qa": "document_media_item" },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_setup.t("Email:", _setup.options)) +
                  "\n      "
              ),
              _c(
                "a",
                {
                  staticClass: "link-decoration-underline primary--text",
                  attrs: {
                    href: "mailto:help@medrocket.ru",
                    "data-qa": "document_media_email_link",
                    target: "_blank",
                    rel: "noopener noreferrer",
                  },
                },
                [_vm._v("\n        help@medrocket.ru\n      ")]
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }